// ============================================================
// Wauvea WebXR — HUD
// Minimal heads-up display: logo, VR button, zone tooltip
// ============================================================

export class HUD {
  constructor() {
    this.overlay = document.getElementById('hud-overlay');
    this.tooltip = document.getElementById('zone-tooltip');
    this.tooltipLabel = document.getElementById('tooltip-label');
    this.vrBtn = document.getElementById('btn-enter-vr');
    this.vrStatus = document.getElementById('vr-status');
  }

  show() {
    this.overlay?.classList.add('visible');
  }

  hide() {
    this.overlay?.classList.remove('visible');
  }

  showTooltip(label) {
    if (this.tooltip && this.tooltipLabel) {
      this.tooltipLabel.textContent = label;
      this.tooltip.classList.add('visible');
      document.body.style.cursor = 'pointer';
    }
  }

  hideTooltip() {
    this.tooltip?.classList.remove('visible');
    document.body.style.cursor = 'grab';
  }

  showVRButton() {
    if (this.vrBtn) {
      this.vrBtn.style.display = 'flex';
    }
  }

  setVRStatus(text) {
    if (this.vrStatus) {
      this.vrStatus.textContent = text;
    }
  }

  setVRActive(active) {
    const span = this.vrBtn?.querySelector('span');
    if (span) {
      span.textContent = active ? 'Exit VR' : 'Enter VR';
    }
  }
}
